export class PatientProfileItem {
  // TODO:値としてはこれだけで大丈夫？（新規追加フラグなど）
  public name: string = "";
  public value: string = "";
  public comment: string = "";
  public isEnabled: boolean = true;

  clone(): PatientProfileItem {
    const cloned = new PatientProfileItem();
    cloned.name = this.name;
    cloned.value = this.value;
    cloned.comment = this.comment;
    cloned.isEnabled = this.isEnabled;
    return cloned;
  }
}
